import { render, staticRenderFns } from "./InterestAssessmentTopic.vue?vue&type=template&id=160f4e52&"
import script from "./InterestAssessmentTopic.vue?vue&type=script&lang=js&"
export * from "./InterestAssessmentTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports